<template>
  <v-navigation-drawer
    app
    :permanent="permanent"
    :temporary="!permanent"
    :value="status"
  >
    <v-list-item>
      EXCOSUP
    </v-list-item>

    <v-divider></v-divider>

    <v-list
      dense
      nav
    >
      <v-list-item exact link to="/">
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Accueil</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item exact link to="/plannings">
        <v-list-item-icon>
          <v-icon>mdi-calendar-month</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Planning</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item exact link to="/documents">
        <v-list-item-icon>
          <v-icon>mdi-folder</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Documents</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/notes">
        <v-list-item-icon>
          <v-icon>mdi-school</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Notes</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/qcm">
        <v-list-item-icon>
          <v-icon>mdi-format-list-checks</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>QCM</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/concours_blancs">
        <v-list-item-icon>
          <v-icon>mdi-format-list-checks</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Concours Blancs</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/annales">
        <v-list-item-icon>
          <v-icon>mdi-format-list-checks</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Annales</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/conversations">
        <v-list-item-icon>
          <v-icon>mdi-forum</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Questions</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/videos">
        <v-list-item-icon>
          <v-icon>mdi-video</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Cours vidéos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/factures">
        <v-list-item-icon>
          <v-icon>mdi-receipt</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Factures</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/envoi-document">
        <v-list-item-icon>
          <v-icon>mdi-cloud-upload</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Envoi document</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/nouvelle-inscription">
        <v-list-item-icon>
          <v-icon>mdi-account-multiple-plus</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Inscription stage</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item href="mailto:contact@excosup.fr">
        <v-list-item-icon>
          <v-icon>mdi-email</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Contact</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider />

    <v-list
      dense
      nav
    >
      <v-list-item link to="/profil">
        <v-list-item-icon>
          <v-icon>mdi-account</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Mon profil</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        @click="downloadSchoolCertificate"
        v-if="student.can_access_school_certificate"
        link
      >
        <v-list-item-icon>
          <v-icon>mdi-file-certificate</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Certificat de scolarité</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/cgu">
        <v-list-item-content>
          <v-list-item-title>CGU</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/cgv">
        <v-list-item-content>
          <v-list-item-title>CGV</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item color="danger" link @click="signOut">
        <v-list-item-content>
          <v-list-item-title>Déconnexion</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    status: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('authentication', ['student']),
    permanent() {
      return ['md', 'lg', 'xl'].includes(this.$vuetify.breakpoint.name);
    },
  },
  methods: {
    ...mapActions('authentication', ['signOut']),
    downloadSchoolCertificate() {
      this.axios({
        url: '/school_certificate',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Certificat de scolarité.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>
